import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class ConfigService {
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    getConfig() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                return yield this.httpClient.get('./assets/config/config.json').toPromise();
            }
            catch (error) {
                const resultado = {
                    status: false,
                    message: 'Error al ejecutar la petición',
                    codeStatus: error.status
                };
                return resultado;
            }
        });
    }
}
ConfigService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ConfigService_Factory() { return new ConfigService(i0.ɵɵinject(i1.HttpClient)); }, token: ConfigService, providedIn: "root" });
